import {Lang} from 'yougile-lang'
import {Tag, UserEvent} from 'yougile-model'
import {Sync} from '@client/sync'
import {Sticker, stickerCtl} from '@extensions/sticker/sticker'

const StickersWithStates = ['string', 'sprint']

export const getActionNameChangeCustom = (event: UserEvent): string => {
  const stringCtl = stickerCtl.String
  const sprintCtl = stickerCtl.Sprint
  const notFound = 'not found'

  if (
    event.type !== 'string' &&
    event.type !== 'sprint' &&
    event.type !== 'numeric' &&
    event.type !== 'text'
  ) {
    return ''
  }

  const ctl = event.type === 'string' ? stringCtl : sprintCtl

  const {options} = event
  if (!options) {
    return ''
  }

  const {id, oldValue, newValue} = options

  const box = Sync.getCurrentSandbox()
  const tag = id && (box.get(id) as Tag)
  if (!tag) {
    return ''
  }

  const name = Sticker.getName(tag)
  const stickerHasStates = StickersWithStates.includes(event.type)
  const newValueStr =
    newValue && stickerHasStates
      ? ctl.getState(tag, newValue)?.name || notFound
      : newValue
  const oldValueStr =
    oldValue && stickerHasStates
      ? ctl.getState(tag, oldValue)?.name || notFound
      : oldValue

  if (oldValueStr === undefined && newValueStr === '') {
    return Lang.msg.statsTimeline.statActionAttachedString(name)
  }
  if (oldValueStr !== undefined && newValueStr === '') {
    return Lang.msg.statsTimeline.statActionRemoveString(name, oldValueStr)
  }
  if (newValueStr !== undefined) {
    if (oldValueStr === '' || oldValueStr === undefined) {
      return Lang.msg.statsTimeline.statActionSetString(name, newValueStr)
    }

    return Lang.msg.statsTimeline.statActionChangeString(
      name,
      oldValueStr,
      newValueStr
    )
  }
  return Lang.msg.statsTimeline.statActionDetachedString(name)
}
